import React, { useState } from 'react';
import FeesListForm from './FeesList';

function FeesCollection({user}) {
  const [activeForm, setActiveForm] = useState(null);

  // Sample data you want to pass
  const selectedStudent = {
    name: 'John Doe',
    class: '10-B',
    id: '1007',
    receiptNo: 'RCPT9876'
  };

  const closeForm = () => setActiveForm(null);

  return (
    <div className="App">
      <button onClick={() => setActiveForm('contact')}>Open Contact Form</button>
      <button onClick={() => setActiveForm('feedback')}>Open Feedback Form</button>

      {/* Pass selectedStudent as a prop to FeesListForm */}
      {activeForm === 'contact' && (
        <FeesListForm onClose={closeForm} studentData={selectedStudent} />
      )}
    </div>
  );
}

export default FeesCollection;
